import { createSlice } from '@reduxjs/toolkit';
import apiClient from 'root/lib/apiClient';
import { Sentry } from 'root/utils/raven';

const initialState = {
  items: {},
  isLoading: false,
  error: null
};

const authorsSlice = createSlice({
  name: 'authors',
  initialState,
  reducers: {
    getAuthorStart(state) {
      state.isLoading = true;
    },
    getAuthorSuccess(state, { payload: { slug, data } }) {
      state.items[slug] = data;
      state.isLoading = false;
      state.error = null;
    },
    getAuthorFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const {
  getAuthorStart,
  getAuthorSuccess,
  getAuthorFailure,
} = authorsSlice.actions;

export default authorsSlice.reducer;

export const fetchAuthor = (slug) => async (dispatch, getState) => {
  const { authors } = getState();
  if (authors.items[slug] && !authors.items[slug]?.length) {
    dispatch(getAuthorSuccess({
      slug,
      data: authors.items[slug],
    }));
  } else {
    try {
      dispatch(getAuthorStart());
      const data = await apiClient({ method: 'GET', url: `/wp-json/mc/v1/users/${slug}` });
      dispatch(getAuthorSuccess({
        slug,
        data,
      }));
    } catch (e) {
      dispatch(getAuthorFailure(e.toString()));
      Sentry.captureException(e);
    }
  }
};

export const setAuthor = ({ slug, data }) => getAuthorSuccess({
  slug,
  data,
});
